/**
 *
 * Asynchronously loads the component for AppointmentNote
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
